/** Keep a series on the same palette slot when its rank or date range changes. */
export function chartColorIndex(key: string | null, label: string, colorCount: number) {
  if (colorCount < 1) return 0
  const identity = key ?? `label:${label}`
  let hash = 2166136261
  for (let index = 0; index < identity.length; index += 1) {
    hash ^= identity.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return (hash >>> 0) % colorCount
}
